export default __webpack_public_path__ + "static/media/Facebook - Original.da305036.svg";